import Toastify from 'spc-general-component/lib/Toastify'
import formModule from '../modules/form'
import listModule from '../modules/list'
import customerModule from '../modules/customer'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { fetchPOST,fetchGET } from '../api/fetchers'
import moment from 'moment'
import { customerProfile } from '../utils'
import { cookieStorage } from '../utils'

const HOST = process.env.REACT_APP_HOST || ''
const HOST_ODOO = process.env.REACT_APP_ODOO_HOST || ''
const HOST_ICC = process.env.REACT_APP_ICC_HOST || ''
const SECRET_KEY_ICC = process.env.REACT_APP_SECRET_KEY_ICC || ''
const KEY_ODOO = process.env.REACT_APP_ODOO_KEY || ''
const HOST_OTP = process.env.REACT_APP_OTP_HOST || ''
const COMPANY_CODE = process.env.REACT_APP_COMPANY_CODE || ''
const ORG_CODE = process.env.REACT_APP_ORG_CODE || ''
const SALESMAN_CODE = process.env.REACT_APP_SALESMAN_CODE || ''
const WAREHOUSE_CUSTOMER_CODE = process.env.REACT_APP_WAREHOUSE_CUSTOMER_CODE || ''
const CREATE_BY = process.env.REACT_APP_CREATE_BY || ''
const GROUP_EMPLOYEE_ICC_CODE = process.env.REACT_APP_GROUP_EMPLOYEE_ICC_CODE || ''
const GROUP_EMPLOYEE_CODE = process.env.REACT_APP_GROUP_EMPLOYEE_CODE || ''
const GROUP_GENERAL_CODE = process.env.REACT_APP_GROUP_GENERAL_CODE || ''
const HOST_ETC = process.env.REACT_APP_WS_ETC_HOST || ''
const KEY_ETC = process.env.REACT_APP_ETC_KEY || ''
const SECRET_ETC = process.env.REACT_APP_ETC_SECRET || ''

const COOKIESEXDAY = process.env.REACT_APP_COOKIESEXDAY || ''
const COOKIESCNAME = process.env.REACT_APP_COOKIESCNAME || ''


const updateSpecificCustomerAction = ({ listName, newList }) => {
  return async (dispatch, getState) => {
    try {
      const list = getState().customer
      list[listName] = newList
      dispatch(
        customerModule.setData({
          data: { ...list }
        })
      )
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'Update Specific Customer Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const getOTPAuthenAction = ({ onCallBackAction = () => {},telephone }) => {
  return async (dispatch, getState) => {
    try {
      const otpInfo = get(getState(), 'form.otpInfo', {})
      const responseToken = await fetchPOST({
        url: `${HOST_OTP}/auth/generateTokenWrapper`
      })
      const token = get(responseToken,'data.result.token','')
      const response = await fetchPOST({
        useMock: false,
        jsonMock: `GetOTPAuthen.json`,
        url: `${HOST_OTP}/v2/b2b/sms/requestOTP`,
        headers:{
          Authorization: `Bearer ${token}`
        },
        data: {
          "telephone" : telephone
        }
      })

      const success = get(response, 'data.success', false)
      const reference = get(response, 'data.result', '')
      const resultMsg = get(response, 'data.resultMsg', '')
      onCallBackAction({
        success,
        reference,
        resultMsg
      })
      dispatch(formModule.updateFormData({
        data: {
          'otpInfo': {
            ...otpInfo,
            OTPCode: get(response, 'data.result.OTPCode', ''),
            referenceno: get(response, 'data.result.referenceno', ''),
            genOTP: true
          }
        }
      }))
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get OTP Authen Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const getOTPCodeAction = ({ reference, telephone }) => {
  return async (dispatch, getState) => {
    try {
      const otpInfo = get(getState(), 'form.otpInfo', {})
      const responseToken = await fetchPOST({
        url: `${HOST_OTP}/auth/generateTokenWrapper`,
      })
      const token = get(responseToken,'data.result.token','')
      const response = await fetchPOST({
        useMock: false,
        jsonMock: `GetOTP.json`,
        url: `${HOST_OTP}/v2/b2b/sms/verifyOTP`,
        headers:{
          Authorization: `Bearer ${token}`
        },
        data: {
          telephone: telephone,
        }
      })

      dispatch(formModule.updateFormData({
        data: {
          'otpInfo': {
            ...otpInfo,
            OTPCode: get(response, 'data.result.OTPCode', ''),
            referenceno: get(response, 'data.result.referenceno', ''),
            genOTP: true
          }
        }
      }))

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get OTP Code Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const onVerifyOTPAction = ({ onCallBackAction= () => {} }) => {
  return async (dispatch, getState) => {
    try {
      
      const otpInfo = get(getState(), 'form.otpInfo', {})
      const responseToken = await fetchPOST({
        url: `${HOST_OTP}/auth/generateTokenWrapper`
      })
      const token = get(responseToken,'data.result.token','')
      const response = await fetchPOST({
        useMock: false,
        jsonMock: `GetVerifyOTP.json`,
        url: `${HOST_OTP}/v2/b2b/sms/verifyOTP`,
        headers:{
          Authorization: `Bearer ${token}`
        },
        data: {
          "telephone": otpInfo?.phoneNumber,
          "otp": otpInfo?.OTP,
          "refcode": otpInfo?.referenceno
        }
      })

      onCallBackAction({
        success: get(response, 'data.success', false),
        reason: get(response, 'data.reason', '')
      })

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Verify OTP Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const onAddNewAddressAction = ({ onCallBackAction= () => {} ,addressType='daddress'}) => {
  return async (dispatch, getState) => {
    try {
      
      const customerFormInfo = get(getState(), 'form.customerInfo', {})
      const customerInfo = get(getState(), 'customer.customerProfile', {})
      const otpInfo = get(getState(), 'form.otpInfo', {})

      const responseCustomer = await fetchPOST({
        url: `${HOST}/sahapatdelivery/b2cexistingsignup`,
        data: {
          "orgcode":ORG_CODE,
          "companycode": COMPANY_CODE,
          "telephone": otpInfo?.phoneNumber || customerInfo?.telephone
        }
      })
      
      const customerData = get(responseCustomer ,'data.result',{})
      if(isEmpty(customerData) && addressType === 'daddress'){
         const responseRegister = await fetchPOST({
          useMock: false,
          jsonMock: `GetAddressList0908858995.json`,
          url: `${HOST}/sahapatdelivery/b2cregistercustomerGeneral`,
          data: {
            "orgcode":ORG_CODE,
            "companycode":COMPANY_CODE,
            "telephone":customerFormInfo?.telephone,
            "password":"",
            "customercode":"",
            "firstname":customerFormInfo?.firstname,
            "lastname":customerFormInfo?.lastname,
            "gender":customerFormInfo?.gender,
            "birthdate": customerFormInfo?.birthdate ? moment(customerFormInfo?.birthdate).format('YYYY-MM-DD') : ''
          }
        })

        const registerData = get(responseRegister ,'data.result',{})
        const responseB2BNewCustomer = await fetchPOST({
            url: `${HOST}/b2b/v1/Customer/b2bnewcustomer`,
            data: {
              "SALESMANCODE":SALESMAN_CODE,
              "CUSTOMERNAME": `${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
              "ADDRESS": customerFormInfo?.address,
              "PROVINCE": customerFormInfo?.provincecode,
              "AMPHUR":customerFormInfo?.amphurcode.slice(-2),
              "DISTRICT":customerFormInfo?.districtcode.slice(-2),
              "ZIPCODE": customerFormInfo?.zipcode,
              "TELEPHONE":customerFormInfo?.telephone,
              "TAXID":"",
              "WAREHOUSECODE":WAREHOUSE_CUSTOMER_CODE
            }
          })
          
          const B2BNewCustomer = get(responseB2BNewCustomer ,'data.result[0]',{})

             await fetchPOST({
              url: `${HOST}/b2b/v1/Customer/createCustomerBO`,
              data: {
                orgcode: ORG_CODE,
                companycode: COMPANY_CODE,
                customercode: B2BNewCustomer?.code,
                customername: `${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
                email: '',
                telephone: customerFormInfo?.telephone,
                password: '',
                remember_token: '',
                b2bcustomercode: B2BNewCustomer?.code,
                active: '1',
                createby: CREATE_BY,
                customergroupcode: registerData.groupcode,
                iaddress: [
                  {
                    "orgcode":ORG_CODE,
                    "companycode":COMPANY_CODE,
                    "b2bcustomercode": B2BNewCustomer?.code,
                    "seq":"",
                    "address": customerFormInfo?.address,
                    "district": customerFormInfo?.districtcode.slice(-2),
                    "amphur":customerFormInfo?.amphurcode.slice(-2),
                    "province":customerFormInfo?.provincecode,
                    "zipcode":customerFormInfo?.zipcode,
                    "telephone":customerFormInfo?.telephone,
                    "taxid":"",
                    "createby":CREATE_BY
                  }
                ],
                daddress: [
                  {
                    "orgcode":ORG_CODE,
                    "companycode":COMPANY_CODE,
                    "b2bcustomercode":B2BNewCustomer?.code,
                    "seq":"",
                    "address":customerFormInfo?.address,
                    "district":customerFormInfo?.districtcode.slice(-2),
                    "amphur":customerFormInfo?.amphurcode.slice(-2),
                    "province":customerFormInfo?.provincecode,
                    "zipcode":customerFormInfo?.zipcode,
                    "telephone":customerFormInfo?.telephone,
                    "taxid":"",
                    "remarks":"",
                    "createby":CREATE_BY,
                    "b2bcustomername":`${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`
                  }
                ],
              }
            })
          }

          if(!isEmpty(customerData) && addressType === 'daddress'){
            const responseCheckProfile = await fetchPOST({
              url: `${HOST}/b2b/v1/Customer/get`,
              data: {
                "orgcode":"SPC",
                "companycode":COMPANY_CODE,
                "ephone": customerInfo?.loginWith ? customerInfo?.email : (customerData?.telephone ? customerData?.telephone : otpInfo?.phoneNumber)
              }
            })

            //เป็นพนักงาน sahapat แต่ยังไม่เคยใช้ delivery
            if(!get(responseCheckProfile, 'data.result', null)){
              const responseRegister = await fetchPOST({
                useMock: false,
                jsonMock: `GetAddressList0908858995.json`,
                url: `${HOST}/sahapatdelivery/b2cregistercustomerGeneral`,
                data: {
                  "orgcode":ORG_CODE,
                  "companycode":COMPANY_CODE,
                  "telephone":customerFormInfo?.telephone,
                  "password":"",
                  "customercode":"",
                  "firstname":customerFormInfo?.firstname,
                  "lastname":customerFormInfo?.lastname,
                  "gender":customerFormInfo?.gender,
                  "birthdate": customerFormInfo?.birthdate ? moment(customerFormInfo?.birthdate).format('YYYY-MM-DD') : ''
                }
              })
      
              const registerData = get(responseRegister ,'data.result',{})
              const responseB2BNewCustomer = await fetchPOST({
                  url: `${HOST}/b2b/v1/Customer/b2bnewcustomer`,
                  data: {
                    "SALESMANCODE":SALESMAN_CODE,
                    "CUSTOMERNAME": `${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
                    "ADDRESS": customerFormInfo?.address,
                    "PROVINCE": customerFormInfo?.provincecode,
                    "AMPHUR":customerFormInfo?.amphurcode.slice(-2),
                    "DISTRICT":customerFormInfo?.districtcode.slice(-2),
                    "ZIPCODE": customerFormInfo?.zipcode,
                    "TELEPHONE":customerFormInfo?.telephone,
                    "TAXID":"",
                    "WAREHOUSECODE":WAREHOUSE_CUSTOMER_CODE
                  }
                })
                
                const B2BNewCustomer = get(responseB2BNewCustomer ,'data.result[0]',{})
      
                  await fetchPOST({
                    url: `${HOST}/b2b/v1/Customer/createCustomerBO`,
                    data: {
                      orgcode: ORG_CODE,
                      companycode: COMPANY_CODE,
                      customercode: B2BNewCustomer?.code,
                      customername: `${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
                      email: '',
                      telephone: customerFormInfo?.telephone,
                      password: '',
                      remember_token: '',
                      b2bcustomercode: B2BNewCustomer?.code,
                      active: '1',
                      createby: CREATE_BY,
                      customergroupcode: registerData.groupcode,
                      iaddress: [
                        {
                          "orgcode":ORG_CODE,
                          "companycode":COMPANY_CODE,
                          "b2bcustomercode": B2BNewCustomer?.code,
                          "seq":"",
                          "address": customerFormInfo?.address,
                          "district": customerFormInfo?.districtcode.slice(-2),
                          "amphur":customerFormInfo?.amphurcode.slice(-2),
                          "province":customerFormInfo?.provincecode,
                          "zipcode":customerFormInfo?.zipcode,
                          "telephone":customerFormInfo?.telephone,
                          "taxid":"",
                          "createby":CREATE_BY
                        }
                      ],
                      daddress: [
                        {
                          "orgcode":ORG_CODE,
                          "companycode":COMPANY_CODE,
                          "b2bcustomercode":B2BNewCustomer?.code,
                          "seq":"",
                          "address":customerFormInfo?.address,
                          "district":customerFormInfo?.districtcode.slice(-2),
                          "amphur":customerFormInfo?.amphurcode.slice(-2),
                          "province":customerFormInfo?.provincecode,
                          "zipcode":customerFormInfo?.zipcode,
                          "telephone":customerFormInfo?.telephone,
                          "taxid":"",
                          "remarks":"",
                          "createby":CREATE_BY,
                          "b2bcustomername":`${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`
                        }
                      ],
                    }
                  })
            }

            //เพิ่มที่อยู่ทั่วไป
            if(get(responseCheckProfile, 'data.result', null)){
            await fetchPOST({
              url: `${HOST}/b2b/v1/Customer/createDAddress`,
              data: {
                  "orgcode":ORG_CODE,
                  "companycode":COMPANY_CODE,
                  "b2bcustomercode": customerInfo.b2bcustomercode,
                  "seq":"",
                  "address":customerFormInfo.address,
                  "district":customerFormInfo.districtcode.slice(-2),
                  "amphur":customerFormInfo.amphurcode.slice(-2),
                  "province":customerFormInfo.provincecode,
                  "zipcode":customerFormInfo.zipcode,
                  "telephone":customerFormInfo.telephone,
                  "taxid":"",
                  "remarks":"",
                  "b2bcustomername":`${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
                  "createby":CREATE_BY
              }
            })
            }

        }

        if(!isEmpty(customerData) && addressType === 'invAddress'){
          await fetchPOST({
            url: `${HOST}/b2b/v2/Customer/updateIAddress`,
            data: {
                "orgcode":ORG_CODE,
                "companycode":COMPANY_CODE,
                "b2bcustomercode": customerInfo.b2bcustomercode,
                "seq":"1",
                "address":customerFormInfo.address,
                "district":customerFormInfo.districtcode.slice(-2),
                "amphur":customerFormInfo.amphurcode.slice(-2),
                "province":customerFormInfo.provincecode,
                "zipcode":customerFormInfo.zipcode,
                "telephone":customerFormInfo.telephone,
                "taxid":customerFormInfo?.taxId,
                "remarks":"",
                "customername":`${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
                "email":customerFormInfo?.email,
                "createby":CREATE_BY
            }
          })
        }
        
        const responseProfile = await fetchPOST({
          url: `${HOST}/b2b/v1/Customer/get`,
          data: {
            "orgcode":"SPC",
            "companycode":COMPANY_CODE,
            "ephone": customerInfo?.loginWith ? customerInfo?.email : (customerData?.telephone ? customerData?.telephone : otpInfo?.phoneNumber)
          }
        })

        // const customerAddressList = get(responseProfile, 'data.result.daddress2', [])
        const profile = get(responseProfile, 'data.result', [])
        if(!isEmpty(profile)) {
          customerProfile.setProfile({
            ...profile,
            loginWith: customerInfo?.loginWith || null,
            customergroupcode: customerData?.groupcode ? customerData?.groupcode : profile?.customergroupcode,
          })
          dispatch(listModule.setDataList({
            data: {
              'customerAddressList': {address:[...get(profile, 'daddress2', []) ]}
            }
          }))
  
          dispatch(customerModule.updateFormData({
            data: {
              'customerProfile': {
                ...profile,
                loginWith: customerInfo?.loginWith || null,
                customergroupcode: customerData?.groupcode ? customerData?.groupcode : profile?.customergroupcode,
              }
            }
          }))
        }
        
        onCallBackAction({ data: profile })
    }  catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API On Add New Address Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const onAddNewAddressSocialAction = ({ onCallBackAction= () => {} ,addressType='daddress'}) => {
  return async (dispatch, getState) => {
    try {
      
      const customerFormInfo = get(getState(), 'form.customerInfo', {})
      const customerInfo = get(getState(), 'customer.customerProfile', {})

      const responseCheckProfile = await fetchPOST({
        url: `${HOST}/b2b/v1/Customer/get`,
        data: {
          "orgcode":"SPC",
          "companycode":COMPANY_CODE,
          "ephone": customerInfo?.email
        }
      })

      if(get(responseCheckProfile, 'data.result', null) && addressType === 'daddress'){
        await fetchPOST({
          url: `${HOST}/b2b/v1/Customer/createDAddress`,
          data: {
              "orgcode":ORG_CODE,
              "companycode":COMPANY_CODE,
              "b2bcustomercode": customerInfo.b2bcustomercode,
              "seq":"",
              "address":customerFormInfo.address,
              "district":customerFormInfo.districtcode.slice(-2),
              "amphur":customerFormInfo.amphurcode.slice(-2),
              "province":customerFormInfo.provincecode,
              "zipcode":customerFormInfo.zipcode,
              "telephone":customerFormInfo.telephone,
              "taxid":"",
              "remarks":"",
              "b2bcustomername":`${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
              "createby":CREATE_BY
          }
        })
      }

      if(get(responseCheckProfile, 'data.result', null) && addressType === 'invAddress'){
        await fetchPOST({
          url: `${HOST}/b2b/v2/Customer/updateIAddress`,
          data: {
              "orgcode":ORG_CODE,
              "companycode":COMPANY_CODE,
              "b2bcustomercode": customerInfo.b2bcustomercode,
              "seq":"1",
              "address":customerFormInfo.address,
              "district":customerFormInfo.districtcode.slice(-2),
              "amphur":customerFormInfo.amphurcode.slice(-2),
              "province":customerFormInfo.provincecode,
              "zipcode":customerFormInfo.zipcode,
              "telephone":customerFormInfo.telephone,
              "taxid":customerFormInfo?.taxId,
              "remarks":"",
              "customername":`${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
              "email":customerFormInfo?.email,
              "createby":CREATE_BY
          }
        })
      }
        

      const responseProfile = await fetchPOST({
        url: `${HOST}/b2b/v1/Customer/get`,
        data: {
          "orgcode":"SPC",
          "companycode":COMPANY_CODE,
          "ephone": customerInfo?.email
        }
      })
          
    
        const profile = get(responseProfile, 'data.result', [])
        if(!isEmpty(profile)) {
          customerProfile.setProfile({...profile,loginWith: customerInfo?.loginWith || null})
          dispatch(listModule.setDataList({
            data: {
              'customerAddressList': {address:[...get(profile, 'daddress2', []) ]}
            }
          }))
  
          dispatch(customerModule.updateFormData({
            data: {
              'customerProfile': {
                ...get(responseProfile, 'data.result', {}) ,
                loginWith: customerInfo?.loginWith || null
              }
            }
          }))
        }
        
        onCallBackAction({ data: profile })
    }  catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API On Add New Address Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const getCustomerAddressListAction = ({phoneNumberOrEmail,loginWith=null, onCallBackAction= () => {} }) => {
  return async (dispatch, getState) => {
    try {
      const otpInfo = get(getState(), 'form.otpInfo', {})
      
      const responseExitSignUp = await fetchPOST({
        url: `${HOST}/sahapatdelivery/b2cexistingsignup`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "employeecode":otpInfo?.EmployeeCode,
          "telephone":otpInfo?.EmployeeCode ? '' : loginWith === null ? phoneNumberOrEmail : '',
          "email":otpInfo?.EmployeeCode ? '' : loginWith !== null ? phoneNumberOrEmail : '',
        }
      })

      const exitSignUp = get(responseExitSignUp, 'data.result', {})
      const responseCustomer = await fetchPOST({
        url: `${HOST}/b2b/v1/Customer/get`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "ephone": phoneNumberOrEmail ? phoneNumberOrEmail : otpInfo?.phoneNumber
        }
      })
     
      const customerAddressList = get(responseCustomer, 'data.result', {})
      if(!isEmpty(customerAddressList)) {
        customerProfile.setProfile({
          ...customerAddressList,
          loginWith:loginWith,
          customergroupcode: exitSignUp?.groupcode ? exitSignUp?.groupcode : customerAddressList?.customergroupcode,
        })
        dispatch(customerModule.setData({
          data: {
            'customerProfile': {
              ...customerAddressList,
              loginWith:loginWith,
              customergroupcode: exitSignUp?.groupcode ? exitSignUp?.groupcode : customerAddressList?.customergroupcode,
            }
          }
        }))
      }

      onCallBackAction({ 
        data: get(customerAddressList, 'daddress2', []) 
      })
      
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API Get Customer Address List Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const onLogoutAction = (isCheck = false) => {
  return async (dispatch) => {
    try {
      customerProfile.logout()
      dispatch(customerModule.setData({
        data: {
          'customerProfile': {}
        }
      }))
      cookieStorage.set({ cname: COOKIESCNAME, cvalue: false, exdays: -1 })
      if (!isCheck) {
        window.history.pushState({}, null, `/`)
        window.location = ''
      }
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'Logout ไม่สำเร็จ กรุณาลองอีกครั้ง',
        closeTime: 5 // Seconds
      })
    }
  }
}

const loginWithFacebookAction = ({data,onCallBackAction = () =>{}}) => {
  return async (dispatch,getState) => {
    try {

      await fetchPOST({
        useMock: false,
        jsonMock: `GetAddressList0908858995.json`,
        url: `${HOST}/sahapatdelivery/v2/createcustomerbyfacebook`,
        data: {
          "orgcode": ORG_CODE,
          "companycode": COMPANY_CODE,
          "firstname": data?.firstName,
          "lastname": data?.lastName,
          "email": data?.email,
          "facebook_id": data?.id,
          "profileimage": data?.profilePicURL && data?.profilePicURL?.lenght < 256 ? data?.profilePicURL : '',
          "displayname": data?.name,
          "status": 'N',
          "telephone": '',
          "createdate": new Date(),
          "employeecode": '',
          "customercode": '',
          "username": '',
          "password": '',
          "gender": '',
          "birthdate": '',
          "statusmessage": '',
          "remember_token": '',
          "ip": '',
        }
      })

      const responseProfile = await fetchPOST({
        url: `${HOST}/b2b/v1/Customer/get`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "ephone": data?.email
        }
      })
      cookieStorage.set({ cname: COOKIESCNAME, cvalue: true, exdays: COOKIESEXDAY })
      onCallBackAction({
        data: get(responseProfile, 'data.result', {})
      })

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API On LoginWithFacebookAction is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const loginWithGoogleAction = ({data,onCallBackAction = () =>{}}) => {
  return async (dispatch) => {
    try {
     
      await fetchPOST({
        useMock: false,
        jsonMock: `GetAddressList0908858995.json`,
        url: `${HOST}/sahapatdelivery/v2/createcustomerbygoogle`,
        data: {
          "orgcode": ORG_CODE,
          "companycode": COMPANY_CODE,
          "firstname": data?.firstName,
          "lastname": data?.lastName,
          "email": data?.email,
          "google_id": data?.id,
          "profileimage": data?.profilePicURL && data?.profilePicURL.lenght < 256 ? data?.profilePicURL : '',
          "displayname": data?.name,
          "status": 'N',
          "telephone": '',
          "createdate": new Date(),
          "employeecode": '',
          "customercode": '',
          "username": '',
          "password": '',
          "gender": '',
          "birthdate": '',
          "statusmessage": '',
          "remember_token": '',
          "ip": '',
        }
      })

      const responseProfile = await fetchPOST({
        url: `${HOST}/b2b/v1/Customer/get`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "ephone": data?.email
        }
      })
      cookieStorage.set({ cname: COOKIESCNAME, cvalue: true, exdays: COOKIESEXDAY })
      onCallBackAction({
        data: get(responseProfile, 'data.result', {})
      })

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API On LoginWithGoogleAction is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const loginWithSPCAction = ({onCallBackAction = () => {}}) => {
  return async (dispatch,getState) => {
    try {
      const otpInfo = get(getState(), 'form.otpInfo', {})

      const response = await fetchPOST({
        useMock: false,
        jsonMock: `GetAddressList0908858995.json`,
        url: `${HOST}/b2b/v1/Customer/getEmployeeInfo`,
        data: {
          'employeeNumber' : otpInfo?.EmployeeCode
        }
      })

      const responseExitSignUp = await fetchPOST({
        url: `${HOST}/sahapatdelivery/b2cexistingsignup`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "employeecode":otpInfo?.EmployeeCode
        }
      })

      const dataSPC = get(response, 'data', {})
      const exitSignUp = get(responseExitSignUp, 'data.result', {})

      onCallBackAction({
        dataSPC:dataSPC,
        exitSignUp:exitSignUp
      })

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API On LoginWithSPCAction is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const loginWithICCAction = ({onCallBackAction = () => {}}) => {
  return async (dispatch,getState) => {
    try {
      const otpInfo = get(getState(), 'form.otpInfo', {})

      const responseAccessToken = await fetchPOST({
        url: `${HOST_ICC}/sahapat_delivery/sahapat_authen/refreshtoken`,
        data: {
            "userId": "SAHAPAT_DELIVERY",
            "secretKey": SECRET_KEY_ICC,
            "expireDay": 30
        }
      })
      
      const responseUserICC = await fetchGET({
        url: `${HOST_ICC}/sahapatdelivery/icc/checkemp`,
        headers: { 'Authorization': `Bearer ${get(responseAccessToken, 'data.data.accessToken', '')}` },
        params: {
          'empid' : otpInfo?.EmployeeCode
        }
      })

      const responseExitSignUp = await fetchPOST({
        url: `${HOST}/sahapatdelivery/b2cexistingsignup`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "employeecode":otpInfo?.EmployeeCode,
          "partnercode":"ICC"
        }
      })

      const dataICC = get(responseUserICC, 'data.data', {})
      const exitSignUp = get(responseExitSignUp, 'data.result', {})

      onCallBackAction({
        dataICC:dataICC,
        exitSignUp:exitSignUp

      })

    } catch (error) {

      if (error.message === 'Not Found') {
        Toastify({
          position: 'center', // left, right, center is default
          type: 'ERROR', // ERROR, WARNING, LOADING, INFO
          message: 'หากพบปัญหาการ log in เข้าระบบด้วยรหัสพนักงาน กรุณาติดต่อ Line @sahapatdelivery',
          closeTime: 5 // Seconds
        })
        return;
      }

      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API On LoginWithICCAction is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const signupWithICCAction = ({onCallBackAction = () => {}}) => {
  return async (dispatch,getState) => {
    try {

      const customerFormInfo = get(getState(), 'form.customerInfo', {})
      const otpInfo = get(getState(), 'form.otpInfo', {})

      await fetchPOST({
        url: `${HOST}/sahapatdelivery/b2ccreatecustomerSPCBO`,
        data: {
            "orgcode": ORG_CODE,
            "companycode": COMPANY_CODE,
            "employeecode": customerFormInfo?.emp_icc_id,
            "customercode": "",
            "username": "",
            "password": "",
            "firstname": customerFormInfo?.firstname,
            "lastname": customerFormInfo?.lastname,
            "email": "",
            "telephone": otpInfo?.phoneNumber,
            "profileimage": "",
            "displayname": "",
            "statusmessage": "",
            "remember_token": "",
            "ip": "",
            "status": "N",
            "createdate": moment().format('YYYY-MM-DD 00:00:00'),
            "partnercode": "ICC",
            "gender": customerFormInfo?.gender,
            "birthdate": customerFormInfo?.birthdate ? moment(customerFormInfo?.birthdate).format('YYYY-MM-DD') : '',
            "groupcode": GROUP_EMPLOYEE_ICC_CODE,
        }
      })

      await fetchPOST({
        useMock: false,
        jsonMock: `GetAddressList0908858995.json`,
        url: `${HOST}/sahapatdelivery/b2cregistercustomerGeneral`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "telephone":otpInfo?.phoneNumber,
          "password":"",
          "customercode":"",
          "firstname":customerFormInfo?.firstname,
          "lastname":customerFormInfo?.lastname,
          "gender":customerFormInfo?.gender,
          "birthdate": customerFormInfo?.birthdate ? moment(customerFormInfo?.birthdate).format('YYYY-MM-DD') : ''
        }
      })

      // const registerData = get(responseRegister ,'data.result',{})
      const responseB2BNewCustomer = await fetchPOST({
          url: `${HOST}/b2b/v1/Customer/b2bnewcustomer`,
          data: {
            "SALESMANCODE":SALESMAN_CODE,
            "CUSTOMERNAME": `${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
            "ADDRESS": customerFormInfo?.address,
            "PROVINCE": customerFormInfo?.provincecode,
            "AMPHUR":customerFormInfo?.amphurcode.slice(-2),
            "DISTRICT":customerFormInfo?.districtcode.slice(-2),
            "ZIPCODE": customerFormInfo?.zipcode,
            "TELEPHONE":otpInfo?.phoneNumber,
            "TAXID":"",
            "WAREHOUSECODE":WAREHOUSE_CUSTOMER_CODE
          }
        })
        
        const B2BNewCustomer = get(responseB2BNewCustomer ,'data.result[0]',{})

          await fetchPOST({
            url: `${HOST}/b2b/v1/Customer/createCustomerBO`,
            data: {
              orgcode: ORG_CODE,
              companycode: COMPANY_CODE,
              customercode: B2BNewCustomer?.code,
              customername: `${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
              email: '',
              telephone: otpInfo?.phoneNumber,
              password: '',
              remember_token: '',
              b2bcustomercode: B2BNewCustomer?.code,
              active: '1',
              createby: CREATE_BY,
              customergroupcode: GROUP_EMPLOYEE_ICC_CODE,
              iaddress: [
                {
                  "orgcode":ORG_CODE,
                  "companycode":COMPANY_CODE,
                  "b2bcustomercode": B2BNewCustomer?.code,
                  "seq":"",
                  "address": customerFormInfo?.address,
                  "district": customerFormInfo?.districtcode.slice(-2),
                  "amphur":customerFormInfo?.amphurcode.slice(-2),
                  "province":customerFormInfo?.provincecode,
                  "zipcode":customerFormInfo?.zipcode,
                  "telephone":otpInfo?.phoneNumber,
                  "taxid":"",
                  "createby":CREATE_BY
                }
              ],
              daddress: [
                {
                  "orgcode":ORG_CODE,
                  "companycode":COMPANY_CODE,
                  "b2bcustomercode":B2BNewCustomer?.code,
                  "seq":"",
                  "address":customerFormInfo?.address,
                  "district":customerFormInfo?.districtcode.slice(-2),
                  "amphur":customerFormInfo?.amphurcode.slice(-2),
                  "province":customerFormInfo?.provincecode,
                  "zipcode":customerFormInfo?.zipcode,
                  "telephone":otpInfo?.phoneNumber,
                  "taxid":"",
                  "remarks":"",
                  "createby":CREATE_BY,
                  "b2bcustomername":`${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`
                }
              ],
            }
          })
          const responseProfile = await fetchPOST({
            url: `${HOST}/b2b/v1/Customer/get`,
            data: {
              "orgcode":ORG_CODE,
              "companycode":COMPANY_CODE,
              "ephone": otpInfo?.phoneNumber
            }
          })
          cookieStorage.set({ cname: COOKIESCNAME, cvalue: true, exdays: COOKIESEXDAY })
          const profile = get(responseProfile, 'data.result', [])
          if(!isEmpty(profile)) {
            customerProfile.setProfile(profile)
            dispatch(listModule.setDataList({
              data: {
                'customerAddressList': {address:[...get(profile, 'daddress2', []) ]}
              }
            }))
    
            dispatch(customerModule.updateFormData({
              data: {
                'customerProfile': {
                  ...get(responseProfile, 'data.result', {}) 
                }
              }
            }))
          }
          
          onCallBackAction({ data: profile })

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API On LoginWithICCAction is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const signupWithSPCAction = ({onCallBackAction = () => {}}) => {
  return async (dispatch,getState) => {
    try {

      const customerFormInfo = get(getState(), 'form.customerInfo', {})
      const responseExistingSignup = await fetchPOST({
        url: `${HOST}/sahapatdelivery/b2cexistingsignup`,
        data: {
            "orgcode": ORG_CODE,
            "companycode": COMPANY_CODE,
            "telephone":customerFormInfo?.telephone,
            "employeecode": customerFormInfo?.emp_id,
            "isAuthened": true,
            "partnercode": "", //TODO test นวเวช
        }
      })
      const existingSignup = get(responseExistingSignup ,'data.result',{})
      const isUpgrade = get(responseExistingSignup ,'data.isUpgrade', false)
      if(!isEmpty(existingSignup)){
        if (!isUpgrade) {
          Toastify({
            position: 'center', // left, right, center is default
            type: 'ERROR', // ERROR, WARNING, LOADING, INFO
            message: 'ไม่สามารถใช้เบอร์โทรนี้ได้',
            closeTime: 5 // Seconds
          })
          return
        }
      } else {
        await fetchPOST({
          url: `${HOST}/sahapatdelivery/b2ccreatecustomerSPCBO`,
          data: {
            "orgcode": ORG_CODE,
            "companycode": COMPANY_CODE,
            "employeecode": customerFormInfo?.emp_id,
            "customercode": "",
            "username": "",
            "password": "",
            "firstname": customerFormInfo?.firstname,
            "lastname": customerFormInfo?.lastname,
            "email": "",
            "telephone": customerFormInfo?.telephone,
            "profileimage": "",
            "displayname": "",
            "statusmessage": "",
            "remember_token": "",
            "ip": "",
            "status": "N",
            "createdate": moment().format('YYYY-MM-DD 00:00:00'),
            "gender": customerFormInfo?.gender,
            "birthdate": customerFormInfo?.birthdate ? moment(customerFormInfo?.birthdate).format('YYYY-MM-DD') : '',
            "groupcode": GROUP_EMPLOYEE_CODE,
          }
        })

        // await fetchPOST({
        //   useMock: false,
        //   jsonMock: `GetAddressList0908858995.json`,
        //   url: `${HOST}/sahapatdelivery/b2cregistercustomerGeneral`,
        //   data: {
        //     "orgcode": ORG_CODE,
        //     "companycode": COMPANY_CODE,
        //     "telephone": customerFormInfo?.telephone,
        //     "password": "",
        //     "customercode": "",
        //     "firstname": customerFormInfo?.firstname,
        //     "lastname": customerFormInfo?.lastname,
        //     "gender": customerFormInfo?.gender,
        //     "birthdate": customerFormInfo?.birthdate ? moment(customerFormInfo?.birthdate).format('YYYY-MM-DD') : ''
        //   }
        // })

        // const registerData = get(responseRegister ,'data.result',{})
        const responseB2BNewCustomer = await fetchPOST({
          url: `${HOST}/b2b/v1/Customer/b2bnewcustomer`,
          data: {
            "SALESMANCODE": SALESMAN_CODE,
            "CUSTOMERNAME": `${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
            "ADDRESS": customerFormInfo?.address,
            "PROVINCE": customerFormInfo?.provincecode,
            "AMPHUR": customerFormInfo?.amphurcode.slice(-2),
            "DISTRICT": customerFormInfo?.districtcode.slice(-2),
            "ZIPCODE": customerFormInfo?.zipcode,
            "TELEPHONE": customerFormInfo?.telephone,
            "TAXID": "",
            "WAREHOUSECODE": WAREHOUSE_CUSTOMER_CODE
          }
        })

        const B2BNewCustomer = get(responseB2BNewCustomer, 'data.result[0]', {})

        await fetchPOST({
          url: `${HOST}/b2b/v1/Customer/createCustomerBO`,
          data: {
            orgcode: ORG_CODE,
            companycode: COMPANY_CODE,
            customercode: B2BNewCustomer?.code,
            customername: `${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
            email: '',
            telephone: customerFormInfo?.telephone,
            password: '',
            remember_token: '',
            b2bcustomercode: B2BNewCustomer?.code,
            active: '1',
            createby: CREATE_BY,
            customergroupcode: GROUP_EMPLOYEE_CODE,
            iaddress: [
              {
                "orgcode": ORG_CODE,
                "companycode": COMPANY_CODE,
                "b2bcustomercode": B2BNewCustomer?.code,
                "seq": "",
                "address": customerFormInfo?.address,
                "district": customerFormInfo?.districtcode.slice(-2),
                "amphur": customerFormInfo?.amphurcode.slice(-2),
                "province": customerFormInfo?.provincecode,
                "zipcode": customerFormInfo?.zipcode,
                "telephone": customerFormInfo?.telephone,
                "taxid": "",
                "createby": CREATE_BY
              }
            ],
            daddress: [
              {
                "orgcode": ORG_CODE,
                "companycode": COMPANY_CODE,
                "b2bcustomercode": B2BNewCustomer?.code,
                "seq": "",
                "address": customerFormInfo?.address,
                "district": customerFormInfo?.districtcode.slice(-2),
                "amphur": customerFormInfo?.amphurcode.slice(-2),
                "province": customerFormInfo?.provincecode,
                "zipcode": customerFormInfo?.zipcode,
                "telephone": customerFormInfo?.telephone,
                "taxid": "",
                "remarks": "",
                "createby": CREATE_BY,
                "b2bcustomername": `${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`
              }
            ],
          }
        })
      }
      
      const responseProfile = await fetchPOST({
        url: `${HOST}/b2b/v1/Customer/get`,
        data: {
          "orgcode":ORG_CODE,
          "companycode":COMPANY_CODE,
          "ephone": customerFormInfo?.telephone
        }
      })
      cookieStorage.set({ cname: COOKIESCNAME, cvalue: true, exdays: COOKIESEXDAY })
      const profile = get(responseProfile, 'data.result', [])
      if(!isEmpty(profile)) {
        customerProfile.setProfile(profile)
        dispatch(listModule.setDataList({
          data: {
            'customerAddressList': {address:[...get(profile, 'daddress2', []) ]}
          }
        }))

        dispatch(customerModule.updateFormData({
          data: {
            'customerProfile': {
              ...get(responseProfile, 'data.result', {}) 
            }
          }
        }))
      }
      
      onCallBackAction({ data: profile })

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API On LoginWithICCAction is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const checkExistICCAction = ({onCallBackAction = () => {}}) => {
  return async (dispatch,getState) => {
    try {

      // const customerFormInfo = get(getState(), 'form.customerInfo', {})
      const otpInfo = get(getState(), 'form.otpInfo', {})

      const responseAccessToken = await fetchPOST({
        url: `${HOST_ICC}/sahapat_delivery/sahapat_authen/refreshtoken`,
        data: {
            "userId": "SAHAPAT_DELIVERY",
            "secretKey": SECRET_KEY_ICC,
            "expireDay": 30
        }
      })
      
      const responseUserICC = await fetchGET({
        url: `${HOST_ICC}/sahapatdelivery/icc/checkemp`,
        headers: { 'Authorization': `Bearer ${get(responseAccessToken, 'data.data.accessToken', '')}` },
        params: {
          'empid' : otpInfo?.EmployeeCode
        }
      })

      const response = await fetchPOST({
        url: `${HOST}/sahapatdelivery/b2cexistingsignup`,
        data: {
            "orgcode": ORG_CODE,
            "companycode": COMPANY_CODE,
            "telephone": otpInfo?.phoneNumber
        }
      })

      onCallBackAction({
        dataICC: get(responseUserICC, 'data.result', {}),
        exitUser: get(response, 'data.result', {})
      })

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API On LoginWithICCAction is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const signupWithSocialAction = ({socialData,loginWith=null,onCallBackAction = () => {}}) => {
  return async (dispatch,getState) => {
    try {

      const customerFormInfo = get(getState(), 'form.customerInfo', {})
      const otpInfo = get(getState(), 'form.otpInfo', {})

      const responseExistingSignup = await fetchPOST({
        url: `${HOST}/sahapatdelivery/b2cexistingsignup`,
        data: {
            "orgcode": ORG_CODE,
            "companycode": COMPANY_CODE,
            "telephone":customerFormInfo?.telephone
        }
      })
      const existingSignup = get(responseExistingSignup ,'data.result',{})
      if(!isEmpty(existingSignup)){
        Toastify({
          position: 'center', // left, right, center is default
          type: 'ERROR', // ERROR, WARNING, LOADING, INFO
          message: 'ไม่สามารถใช้เบอร์โทรนี้ได้',
          closeTime: 5 // Seconds
        })
        return 
      }
          const responseB2BNewCustomer = await fetchPOST({
            url: `${HOST}/b2b/v1/Customer/b2bnewcustomer`,
            data: {
              "SALESMANCODE":SALESMAN_CODE,
              "CUSTOMERNAME": `${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
              "ADDRESS": customerFormInfo?.address,
              "PROVINCE": customerFormInfo?.provincecode,
              "AMPHUR":customerFormInfo?.amphurcode.slice(-2),
              "DISTRICT":customerFormInfo?.districtcode.slice(-2),
              "ZIPCODE": customerFormInfo?.zipcode,
              "TELEPHONE":otpInfo?.phoneNumber || customerFormInfo?.telephone,
              "TAXID":"",
              "WAREHOUSECODE":WAREHOUSE_CUSTOMER_CODE
            }
          })
          const B2BNewCustomer = get(responseB2BNewCustomer ,'data.result[0]',{})
           await fetchPOST({
            url: `${HOST}/b2b/v1/Customer/createCustomerBO`,
            data: {
              orgcode: ORG_CODE,
              companycode: COMPANY_CODE,
              customercode: B2BNewCustomer?.code,
              customername: `${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`,
              email: socialData?.email,
              telephone: otpInfo?.phoneNumber || customerFormInfo?.telephone,
              password: '',
              remember_token: '',
              b2bcustomercode: B2BNewCustomer?.code,
              active: '1',
              createby: CREATE_BY,
              customergroupcode: GROUP_GENERAL_CODE,
              iaddress: [
                {
                  "orgcode":ORG_CODE,
                  "companycode":COMPANY_CODE,
                  "b2bcustomercode": B2BNewCustomer?.code,
                  "seq":"",
                  "address": customerFormInfo?.address,
                  "district": customerFormInfo?.districtcode.slice(-2),
                  "amphur":customerFormInfo?.amphurcode.slice(-2),
                  "province":customerFormInfo?.provincecode,
                  "zipcode":customerFormInfo?.zipcode,
                  "telephone": otpInfo?.phoneNumber || customerFormInfo?.telephone,
                  "taxid":"",
                  "createby":CREATE_BY
               }
              ],
              daddress: [
                {
                  "orgcode":ORG_CODE,
                  "companycode":COMPANY_CODE,
                  "b2bcustomercode":B2BNewCustomer?.code,
                  "seq":"",
                  "address":customerFormInfo?.address,
                  "district":customerFormInfo?.districtcode.slice(-2),
                  "amphur":customerFormInfo?.amphurcode.slice(-2),
                  "province":customerFormInfo?.provincecode,
                  "zipcode":customerFormInfo?.zipcode,
                  "telephone":otpInfo?.phoneNumber || customerFormInfo?.telephone,
                  "taxid":"",
                  "remarks":"",
                  "createby":CREATE_BY,
                  "b2bcustomername":`${customerFormInfo?.firstname} ${customerFormInfo?.lastname}`
               }
              ],
            }
          })

          // const responseExistingSignup = await fetchPOST({
          //   url: `${HOST}/sahapatdelivery/b2cexistingsignup`,
          //   data: {
          //       "orgcode": ORG_CODE,
          //       "companycode": COMPANY_CODE,
          //       "email": socialData?.email 
          //   }
          // })

          // const existingSignup = get(responseExistingSignup, 'data.result', [])
          // await fetchPOST({
          //   url: `${HOST}/b2b/v2/Customer/updateCustLogin`,
          //   data:{ 
          //     "orgcode":ORG_CODE,
          //     "companycode":COMPANY_CODE,
          //     "customer_id":existingSignup?.customer_id,
          //     "telephone":customerFormInfo?.telephone,
          //     "customercode":B2BNewCustomer?.code,
          //     "firstname":customerFormInfo?.firstname,
          //     "lastname":customerFormInfo?.lastname,
          //     "groupcode":existingSignup?.groupcode,
          //     "birthdate":moment().format("YYYY-MM-DD"),
          //     "email":socialData?.email
          //   }
          // })

          const responseProfile = await fetchPOST({
            url: `${HOST}/b2b/v1/Customer/get`,
            data: {
              "orgcode":ORG_CODE,
              "companycode":COMPANY_CODE,
              "ephone": socialData?.email 
            }
          })
          const profile = get(responseProfile, 'data.result', [])
          if(!isEmpty(profile)) {
            customerProfile.setProfile({...profile,loginWith:loginWith})
            dispatch(listModule.setDataList({
              data: {
                'customerAddressList': {address:[...get(profile, 'daddress2', []) ]}
              }
            }))
    
            dispatch(customerModule.updateFormData({
              data: {
                'customerProfile': {
                  ...get(responseProfile, 'data.result', {}),
                  loginWith:loginWith
                }
              }
            }))
          }
          
          onCallBackAction({ data: profile })

    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API On LoginWithSocailAction is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

const checkConsentAction = ({ customerCode }) => {
  return async (dispatch, getState) => {
    try {      
      const responseToken = await fetchPOST({
        url: `${HOST_ETC}/ebizapi_hwc/jwt/generateToken`,
        data: {
          key: KEY_ETC,
          secret: SECRET_ETC
        }
      })
      const token = get(responseToken,'data.result.token','')
      const response = await fetchPOST({
        url: `${HOST_ETC}/api/pdpa/CheckConsent`,
        headers:{
          Authorization: `Bearer ${token}`
        },
        data: {
          "customercode": customerCode,
          "companycode": "B2C"
        }
      })

      return get(response, 'data.result.customerconsent', false);
    } catch (error) {
      Toastify({
        position: 'center', // left, right, center is default
        type: 'ERROR', // ERROR, WARNING, LOADING, INFO
        message: 'API checkConsentAction Action is not working',
        closeTime: 5 // Seconds
      })
    }
  }
}

export {
  getOTPAuthenAction,
  getOTPCodeAction,
  onVerifyOTPAction,
  getCustomerAddressListAction,
  onAddNewAddressAction,
  onLogoutAction,
  updateSpecificCustomerAction,
  loginWithFacebookAction,
  loginWithGoogleAction,
  loginWithSPCAction,
  loginWithICCAction,
  signupWithICCAction,
  checkExistICCAction,
  signupWithSocialAction,
  onAddNewAddressSocialAction,
  signupWithSPCAction,
  checkConsentAction
}